// components/ErrorBoundary/index.jsx
'use client'

import { Button, Result } from 'antd'
import React, { Component, createContext } from 'react'

export const RetryContext = createContext(0)

export default class ErrorBoundary extends Component {
    state = { error: null, retryKey: 0 }

    static getDerivedStateFromError(error) {
        return { error }
    }

    handleRetry = () => {
        this.setState(prev => ({
            error: null,
            retryKey: prev.retryKey + 1
        }))
    }

    render() {
        if (this.state.error) {
            return (
                <Result
                    status="error"
                    title="Load Fail"
                    subTitle={this.state.error.message || this.state.error.msg}
                    extra={[
                        <Button
                            type="primary"
                            key="retry"
                            onClick={this.handleRetry}
                        >
                            try again
                        </Button>
                    ]}
                />
            )
        }

        return (
            <RetryContext.Provider value={this.state.retryKey}>
                {this.props.children}
            </RetryContext.Provider>
        )
    }
}